<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
   
          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">
            <template #type="{ row }">
              <span v-if="row.type==1">意见</span>
              <span v-else-if="row.type==2">充值</span> 
            </template>

            <template #state="{ row }">
            
              <span v-if="row.state==1">等待处理</span> 
              <span v-else-if="row.state==2">已处理</span> 
            </template>
  
             
            <template v-slot:thumbnail="{ row }">
            <img :src="row.pictures" v-if="row.pictures"
              @click="signleImg(row.pictures)" style="width:62.9px;height:80px" />
          </template>
  
            <template v-slot:operator="{ row }"> 
                <lay-button size="xs" type="primary" @click="updateFeedback(row)">回复</lay-button>
              <lay-button size="xs" type="danger" @click="deleFeedback(row)">删除</lay-button>
            </template>
          </lay-table>
  
  
  
        </lay-panel>
  
      </lay-col>
  
    </lay-row>
    <lay-layer v-model="visible11" :shade="false" :area="['400px', '300px']" :btn="action11" title="反馈">
      <div style="padding: 20px;">
        <lay-form :model="advertise" ref="layFormRef11" >  
          <lay-form-item label="" prop="key">
          
            <lay-textarea placeholder="请输入描述"  v-model="advertise.key">
       </lay-textarea>
          </lay-form-item>  

        
  
        </lay-form>
      </div>
    </lay-layer>
  </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allSysFeedback, replyFeedback,delSysFeedback} from '../../api'
  import { getToken } from '@/utils/auth'
  import {getUrl} from '../../api/comfig'
  const  httpUrl=getUrl();

 
 

  
const headers= reactive({
  'token': getToken()
})
  
  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
    { title: "图片", key: "pictures", align: "center" , customSlot: "thumbnail"},
    { title: "标题", key: "title", align: "center" },
    { title: "内容", key: "content", align: "center" },
    { title: "类型", key: "type", align: "center", customSlot: "type" },
    { title: "状态", key: "state", align: "center", customSlot: "state" },  
    { title: "账号", key: "userId", align: "center" }, 
    { title: "回复信息", key: "reply", align: "center" }, 
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllSysFeedback = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit};
    allSysFeedback(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllSysFeedback();
  
  
  const change = (page: any) => {
    getAllSysFeedback();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  

//查看图片

const signleImg = (imgur: any) => {
  layer.photos({
    imgList: [{ src: imgur }]
  })
}
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllSysFeedback();
  }
   
 

  const advertise = reactive({
    id:0,
    key: "", 
  })
  
  
  const deleFeedback = (row: any) => {
       var data={'id':row.id} 
       delSysFeedback(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllSysFeedback(); 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
   
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);

  const updateFeedback= (row: any) => {

    advertise.id = row.id; 
    advertise.reply = row.reply; 
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
 
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        replyFeedback(JSON.stringify(advertise)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllSysFeedback();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
  
      }
    }
  ])
  
  
  </script>
  
  <style scoped></style>